import Big from 'big.js';

import {
  CreateDerivativesOrderRequest,
  CustomerTradingPairConfiguration,
  DerivativesOpenedPositionProjection,
  DerivativesOrderProjection,
  DerivativesOrderSide,
  DerivativesOrderType,
  DerivativesPositionMode,
  DerivativesPositionSide,
  TradingPairContractType,
  TradingPairWithStatsDto,
} from 'common/api/autogenerated/trading-gateway';

import { getDerivativePositionMode } from 'views/derivatives/redux/derivatives.api';
import { tempFuturesConfigurator } from 'views/derivatives/utils/temp-config';

import { DerivativeOrderFormType } from './types';

//

//
// ref: https://dev.azure.com/xbo-tech/FinoCRM/_wiki/wikis/XBO/6485/Order-Create-API-Description
export function convertOrderToServer(data: DerivativeOrderFormType) {
  const {
    tradingPairCode,
    type,
    action,
    positionMode,
    quantity,
    limitPrice,
    triggerPrice,
    tpsl,
    takeProfit,
    stopLoss,
  } = data;

  const request: CreateDerivativesOrderRequest = {
    tradingPairCode,
    type,
    side: action,
    contracts: Number(quantity),
  };

  if (positionMode === DerivativesPositionMode.ONE_WAY) {
    if (action === DerivativesOrderSide.BUY) request.side = DerivativesOrderSide.BUY;
    if (action === DerivativesOrderSide.SELL) request.side = DerivativesOrderSide.SELL;
  }

  // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
  // if (positionMode === DerivativesPositionMode.HEDGE) {
  //   if (action === DerivativesOrderSide.BUY) request.side = DerivativesOrderSide.BUY_OPEN;
  //   if (action === DerivativesOrderSide.SELL) request.side = DerivativesOrderSide.SELL_OPEN;
  // }

  if (tpsl) {
    if (takeProfit) {
      request.takeProfit = {
        triggerPrice: takeProfit,
      };
    }
    if (stopLoss) {
      request.stopLoss = {
        triggerPrice: stopLoss,
      };
    }
  }

  if (!tpsl) {
    request.takeProfit = undefined;
    request.stopLoss = undefined;
  }

  if (!tpsl) {
    request.takeProfit = undefined;
    request.stopLoss = undefined;
  }

  switch (type) {
    case DerivativesOrderType.MARKET:
      // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
      // request.reduceOnly = reduceOnly;
      break;
    case DerivativesOrderType.LIMIT:
      // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
      // request.condition = condition;
      request.price = Number(limitPrice);
      // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
      // request.reduceOnly = reduceOnly;
      break;
    case DerivativesOrderType.STOP_LIMIT:
      request.price = Number(limitPrice);
      request.trigger = {
        price: Number(triggerPrice),
      };
      break;
    case DerivativesOrderType.STOP_MARKET:
      request.trigger = {
        price: Number(triggerPrice),
      };
      break;

    default:
      break;
  }

  return request;
}

type ConvertFromQuantityIntoContractsParams = Pick<TradingPairWithStatsDto, 'contractType' | 'contractValue'> &
  Pick<DerivativesOrderProjection, 'quantity' | 'price'>;

export const createOrderForPartialPositionClose = (
  position: DerivativesOpenedPositionProjection,
  contracts: number,
): CreateDerivativesOrderRequest => {
  const { tradingPairCode, side } = position;

  const order: CreateDerivativesOrderRequest = {
    tradingPairCode,
    type: DerivativesOrderType.MARKET,
    contracts,
    positionId: position.id,
  };

  // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
  // if (mode === DerivativesPositionMode.HEDGE) {
  //   if (side === DerivativesPositionSide.BUY) order.side = DerivativesOrderSide.BUY_CLOSE;
  //   if (side === DerivativesPositionSide.SELL) order.side = DerivativesOrderSide.SELL_CLOSE;
  // }

  // if (mode === DerivativesPositionMode.ONE_WAY) {
  if (side === DerivativesPositionSide.BUY) order.side = DerivativesOrderSide.SELL;
  if (side === DerivativesPositionSide.SELL) order.side = DerivativesOrderSide.BUY;
  // }
  return order;
};

export const convertFromQuantityIntoContracts = ({
  contractType,
  contractValue,
  quantity,
  price,
}: ConvertFromQuantityIntoContractsParams) => {
  if (!contractValue) return 0;

  switch (contractType) {
    case TradingPairContractType.INVERSE:
      return new Big(Number(quantity || 0))
        .times(Number(price || 0))
        .div(contractValue)
        .toNumber();

    case TradingPairContractType.LINEAR:
    default:
      return new Big(Number(quantity || 0)).div(contractValue).toNumber();
  }
};

export function roundUpMargin(number: number, digits: number) {
  return Math.ceil(number * 10 ** digits) / 10 ** digits;
}

export async function enrichConfigWithPositionModeAndSyncLS(response: CustomerTradingPairConfiguration, code: string) {
  let apiPositionMode: DerivativesPositionMode | undefined;

  try {
    apiPositionMode = (await getDerivativePositionMode()).positionMode;
  } catch (error) {
    console.log(error);
  }

  const apiMarginMode = response.marginMode;
  const apiLeverage = response.leverage;
  const apiTakerFeeRate = response.takerFeeRate;

  if (apiMarginMode !== undefined || apiLeverage !== undefined || apiPositionMode !== undefined)
    tempFuturesConfigurator.clear(code);

  return { apiMarginMode, apiLeverage, apiTakerFeeRate, apiPositionMode };
}
